import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import IconButtonWithText from 'srcReact/components/common2/IconButtonWithText'
import styles from './styles.module.scss'
import MixrTiming from '../../components/MixrTiming'
import InviteMembers from '../../components/InviteMembers'
import MixrVenue from '../../components/MixrVenue'
import { formatLastUpdateDate } from 'srcReact/helpers/datetimeHelper'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import MixrPricing from '../MixrPricing'
import MixrAttendance from '../MixrAttendance'

const AdvanceSettings = ({
  isPreviewUpdate,
  setHasFormErrors,
  hasPriceSetting,
  hasInviteSetting,
  hasAttendenceSetting,
  innerContainerCss,
  infoCss,
  editMode = false,
  openEditMixrPopup,
  setDataToUpdateForRecMixr
}) => {
  const { t } = useTranslation()

  const {
    mixr: {
      mixr,
      mixr: { fees, local_invite_send_date, attendance_limits }
    }
  } = useSelector((state) => state)

  const [showPriceSettings, setShowPriceSettings] = useState(false)
  const [showInviteSettings, setShowInviteSettings] = useState(false)
  const [showAttendenceSettings, setShowAttendenceSettings] = useState(false)

  const handleShowContainer = (type) => {
    setShowPriceSettings(false)
    setShowInviteSettings(false)
    setShowAttendenceSettings(false)
    if (type === 'price') {
      setShowPriceSettings(true)
    } else if (type === 'invite') {
      setShowInviteSettings(true)
    } else if (type === 'attendance') {
      setShowAttendenceSettings(true)
    }
  }

  const getFormattedInviteDate = (inviteSendDate) => {
    if (inviteSendDate) {
      const formattedDate = formatLastUpdateDate(new Date(inviteSendDate), appConstantSettings.DATE_FORMAT7, t)
      return formattedDate
    }
    return null
  }

  // const calculateTotalLimit = (limits) => {
  //   let totalLimit = 0
  //   limits?.forEach((limitObj) => {
  //     if (limitObj.limit !== '') {
  //       totalLimit += parseInt(limitObj.limit, 10)
  //     }
  //   })
  //   return totalLimit
  // }

  return (
    <React.Fragment>
      <p className={infoCss}>{t('event.advanceSettings.title1')}</p>
      <div className={`${innerContainerCss} ${styles.wrapper}`}>
        {hasPriceSetting && (
          <IconButtonWithText
            icon='price-icon'
            selected={showPriceSettings}
            text={t('event.advanceSettings.price.title')}
            onClick={() => handleShowContainer('price')}
            textCSS={styles.textCSS}
            labelCSS={styles.labelCSS}
            label={fees?.length > 0 ? t('event.advanceSettings.price.withFee') : t('event.advanceSettings.price.free')}
          />
        )}
        {hasInviteSetting && (
          <IconButtonWithText
            selected={showInviteSettings}
            icon='groups24'
            text={t('event.advanceSettings.invite.title')}
            onClick={() => handleShowContainer('invite')}
            textCSS={styles.textCSS}
            labelCSS={styles.labelCSS}
            label={getFormattedInviteDate(local_invite_send_date) || t('event.advanceSettings.invite.now')}
          />
        )}
        {hasAttendenceSetting && (
          <IconButtonWithText
            selected={showAttendenceSettings}
            icon='groups24'
            text={t('event.advanceSettings.attendance.title')}
            onClick={() => handleShowContainer('attendance')}
            textCSS={styles.textCSS}
            labelCSS={styles.labelCSS}
            label={
              attendance_limits?.length > 0 && (attendance_limits[0].limit > 0 || attendance_limits[1].limit > 0)
                ? t('event.create.venue.withLimit')
                : t('event.advanceSettings.attendance.none')
            }
          />
        )}
      </div>
      {(showPriceSettings || showInviteSettings || showAttendenceSettings) && (
        <div className={innerContainerCss}>
          {showPriceSettings && (
            <MixrPricing
              editMode={editMode}
              previewEditMode={isPreviewUpdate}
              setHasFormErrors={setHasFormErrors}
              openEditMixrPopup={openEditMixrPopup}
              setDataToUpdateForRecMixr={setDataToUpdateForRecMixr}
              setShowPriceSettings={setShowPriceSettings}
            />
          )}
          {showInviteSettings && (
            <InviteMembers
              editMode={editMode}
              showPriceSettings={showInviteSettings}
              previewEditMode={isPreviewUpdate}
              setHasFormErrors={setHasFormErrors}
            />
          )}
          {showAttendenceSettings && (
            <MixrAttendance
              editMode={editMode}
              previewEditMode={isPreviewUpdate}
              openEditMixrPopup={openEditMixrPopup}
              setDataToUpdateForRecMixr={setDataToUpdateForRecMixr}
              setShowAttendenceSettings={setShowAttendenceSettings}
            />
          )}
        </div>
      )}
    </React.Fragment>
  )
}
export default AdvanceSettings
